import * as THREE from "three";

export const KirchhamLabels = [
  {
    Id: "Annotation_KirchhamHeimathaus",
    Titel: "Heimathaus Stegbinder Kirchham",
    TitelEn: "Heimathaus Stegbinder Kirchham",
    Position: new THREE.Vector3(670.596, 11.4592, 84.6282),
    Rotation: new THREE.Vector3(0.0, 0.0, 0),
    Scale: 1,
    isIFrame: true,
    iFrameUrl:"https://traunsee-almtal.salzkammergut.at/oesterreich-poi/detail/430023363/heimathaus-stegbinder.html",
    offset: 15,
    offsetUp: 0,
    follow: true,
    lowModelCamZoom: 15,
  },
  
]

export const  PettenbachLabels = [
  {
    Id: "Annotation_SchriftHeimatBarthaus",
    Titel: "Schrift- und Heimatmuseum Bartlhaus Pettenbach",
    TitelEn: "Schrift- und Heimatmuseum Bartlhaus Pettenbach",
    Position: new THREE.Vector3(657.703, 16.6393, 108.925),
    Rotation: new THREE.Vector3(0.0, 0.0, 0),
    Scale: 1,
    isIFrame: true,
    iFrameUrl:"./PanoTours/MDR/SEKUNDAER/Bartlhaus/index.htm",
    offset: 25,
    offsetUp: 0,
    follow: true,
    lowModelCamZoom: 15,
  },
  
]

export const  ViechtauLabels = [
  {
    Id: "Annotation_HeimathausViechtau",
    Titel: "Heimathaus Viechtau",
    TitelEn: "Heimathaus Viechtau",
    Position: new THREE.Vector3(601.48, 11.2202, 8.59807),
    Rotation: new THREE.Vector3(0.0, 0.0, 0),
    Scale: 1,
    isIFrame: true,
    iFrameUrl:"./PanoTours/MDR/SEKUNDAER/HaimathausViechtau/index.htm",
    offset: -12,
    offsetUp: 0,
    follow: true,
    lowModelCamZoom: 15,
  },
  
]

export const  ScharnsteinLabels = [
  {
    Id: "Annotation_Kriminalmuseum",
    Titel: "Kriminalmuseum Schloss Scharnstein",
    TitelEn: "Kriminalmuseum Schloss Scharnstein",
    Position: new THREE.Vector3(623.652, 12.6613, 87.4104),
    Rotation: new THREE.Vector3(0.0, 0.0, 0),
    Scale: 1,
    isIFrame: true,
    iFrameUrl:"./PanoTours/MDR/SEKUNDAER/Kriminalmuseum/index.htm",
    offset: 20,
    offsetUp: 0,
    follow: true,
    lowModelCamZoom: 15,
  },

  // {
  //   Id: "Annotation_SchlossScharnstein",
  //   Titel: "SchlossScharnstein",
  //   Position: new THREE.Vector3(623.652, 4.95016, 87.4104),
  //   Rotation: new THREE.Vector3(0.0, 0.0, 0),
  //   Scale: 1,
  //   isIFrame: true,
  //   iFrameUrl:
  //     "./PanoTours/MDR//SEKUNDAER/Kriminalmuseum/index.htm",
  //   offset: 15,
  //   offsetUp: 0,
  //   follow: true,
  //   lowModelCamZoom: 15,
  // },

  {
    Id: "Annotation_Sensenmuseum",
    Titel: "Sensenmuseum Geyerhammer Scharnstein",
    TitelEn: "Sensenmuseum Geyerhammer Scharnstein",
    Position: new THREE.Vector3(623.652, 8.13066, 87.4104),
    Rotation: new THREE.Vector3(0.0, 0.0, 0),
    Scale: 1,
    isIFrame: true,
    iFrameUrl:"./PanoTours/MDR/SEKUNDAER/Sensenmuseum/index.htm",
    offset: 21,
    offsetUp: 0,
    follow: true,
    lowModelCamZoom: 15,
  },


  
]

export const  EggerhausLabels = [
 
    {
      Id: "Annotation_Eggerhaus",
      Titel: "Eggerhaus Altmünster",
      TitelEn: "Eggerhaus Altmünster",
      Position: new THREE.Vector3(618.769, 16.6393, 13.726),
      Rotation: new THREE.Vector3(0.0, 0.0, 0),
      Scale: 1,
      isIFrame: true,
      iFrameUrl:"./PanoTours/MDR/SEKUNDAER/Eggerhaus/index.htm",
      offset: 13,
      offsetUp: 0,
      follow: true,
      lowModelCamZoom: 15,
    },


  
]

export const  TraunkirchenLabels = [
 
  {
    Id: "Annotation_ArchekultTraunkirchen",
    Titel: "Archekult Traunkirchen",
    TitelEn: "Archekult Traunkirchen",
    Position: new THREE.Vector3(588.735, 12.2359, 25.7458),
    Rotation: new THREE.Vector3(0.0, 0.0, 0),
    Scale: 1,
    isIFrame: true,
    iFrameUrl:"./PanoTours/MDR/SEKUNDAER/ArchekultTraunkirchen/index.htm",
    offset: 13,
    offsetUp: 0,
    follow: true,
    lowModelCamZoom: 15,
  },

  {
    Id: "Annotation_HandarbeitsmuseumTraunkirchen",
    Titel: "Handarbeitsmuseum Traunkirchen",
    TitelEn: "Handarbeitsmuseum Traunkirchen",
    Position: new THREE.Vector3(588.735, 8.42822, 25.7458),
    Rotation: new THREE.Vector3(0.0, 0.0, 0),
    Scale: 1,
    isIFrame: true,
    iFrameUrl:"./PanoTours/MDR/SEKUNDAER/HandarbeitsmuseumTraunkirchen/index.htm",
    offset: 17,
    offsetUp: 0,
    follow: true,
    lowModelCamZoom: 15,
  },



]

export const  SteinbachAmAtterseeLabels = [
 
  {
    Id: "Annotation_Zwetschkenreich",
    Titel: "Auf dem Laufsteg ins Zwetschkenreich",
    TitelEn: "Auf dem Laufsteg ins Zwetschkenreich",
    Position: new THREE.Vector3(581.1, 21.1896, -69.7964),
    Rotation: new THREE.Vector3(0.0, 0.0, 0),
    Scale: 1,
    isIFrame: true,
    iFrameUrl:"./PanoTours/MDR/SEKUNDAER/Zwetchkenreich/index.htm",
    offset: 19,
    offsetUp: 0,
    follow: true,
    lowModelCamZoom: 15,
  },

  {
    Id: "Annotation_GustavMahlerKomponierhaeusl",
    Titel: "Gustav Mahler-Komponierhäusl",
    TitelEn: "Gustav Mahler's composing cottage",
    Position: new THREE.Vector3(581.1, 16.9005, -69.7964),
    Rotation: new THREE.Vector3(0.0, 0.0, 0),
    Scale: 1,
    isIFrame: true,
    iFrameUrl:"./PanoTours/MDR/SEKUNDAER/GustavMahler/index.htm",
    offset: 15,
    offsetUp: 0,
    follow: true,
    lowModelCamZoom: 15,
  },

  {
    Id: "Annotation_HeimathausSteinbach",
    Titel: "Heimathaus Steinbach am Attersee",
    TitelEn: "Heimathaus Steinbach am Attersee",
    Position: new THREE.Vector3(581.1, 12.1109, -69.7964),
    Rotation: new THREE.Vector3(0.0, 0.0, 0),
    Scale: 1,
    isIFrame: true,
    iFrameUrl:"./PanoTours/MDR/SEKUNDAER/HeimathausSteinbach/index.htm",
    offset: 17,
    offsetUp: 0,
    follow: true,
    lowModelCamZoom: 15,
  },

]

export const  BadIschlLabels = [
 
  {
    Id: "Annotation_LeharvillaBadIschl",
    Titel: "Lehár-Villa Bad Ischl",
    TitelEn: "Lehár-Villa Bad Ischl",
    Position: new THREE.Vector3(519.747, 13.4559, -39.4885),
    Rotation: new THREE.Vector3(0.0, 0.0, 0),
    Scale: 1,
    isIFrame: true,
    iFrameUrl:"https://badischl.salzkammergut.at/oesterreich-poi/detail/430002122/lehar-villa.html",
    offset: 12,
    offsetUp: 0,
    follow: true,
    lowModelCamZoom: 15,
  },
  {
    Id: "Annotation_BadIschlFarhzeugTechnik",
    Titel: "Museum Fahrzeug-Technik-Luftfahrt Bad Ischl",
    TitelEn: "Museum Fahrzeug-Technik-Luftfahrt Bad Ischl",
    Position: new THREE.Vector3(519.747, 17.4611, -39.4885),
    Rotation: new THREE.Vector3(0.0, 0.0, 0),
    Scale: 1,
    isIFrame: true,
    iFrameUrl:"./PanoTours/MDR/SEKUNDAER/BadischlFahrzeugMuseum/index.htm",
    offset: 23,
    offsetUp: 0,
    follow: true,
    lowModelCamZoom: 15,
  },

]


export const  BadGoisernLabels = [
 
  // {
  //   Id: "Annotation_BadGoisernErlebnismuseu",
  //   Titel: "BadGoisern Erlebnismuseum",
  //   Position: new THREE.Vector3(485.477, 11.4723, -46.4699),
  //   Rotation: new THREE.Vector3(0.0, 0.0, 0),
  //   Scale: 1,
  //   isIFrame: true,
  //   iFrameUrl:"./PanoTours/MDR//SEKUNDAER/BadischlFahrzeugMuseum/index.htm",
  //   offset: 15,
  //   offsetUp: 0,
  //   follow: true,
  //   lowModelCamZoom: 15,
  // },

  
  {
    Id: "Annotation_BadGoisernHandwerkhaus",
    Titel: "HAND.WERK.HAUS Salzkammergut Bad Goisern",
    TitelEn: "HAND.WERK.HAUS Salzkammergut Bad Goisern",
    Position: new THREE.Vector3(485.477, 7.66466, -46.4699),
    Rotation: new THREE.Vector3(0.0, 0.0, 0),
    Scale: 1,
    isIFrame: true,
    iFrameUrl:"./PanoTours/MDR/SEKUNDAER/BadGoisernHandwerkhaus/index.htm",
    offset: 15,
    offsetUp: 4,
    follow: true,
    lowModelCamZoom: 15,
  },

  {
    Id: "Annotation_HausmuehleSteinbach",
    Titel: "Erlebnismuseum Anzenaumühle",
    TitelEn: "Erlebnismuseum Anzenaumühle",
    Position: new THREE.Vector3(485.477, 15.6241, -46.4699),
    Rotation: new THREE.Vector3(0.0, 0.0, 0),
    Scale: 1,
    isIFrame: true,
    iFrameUrl:"./PanoTours/MDR/SEKUNDAER/Anzenaumuehle/index.htm",
    offset: 17,
    offsetUp: 0,
    follow: true,
    lowModelCamZoom: 15,
  },

]


export const  GosauLabels = [
 
  // {
  //   Id: "Annotation_GosauFreilichtmuseum",
  //   Titel: "Freilichtmuseum Gosau",
  //   Position: new THREE.Vector3(444.731, 16.6393, -77.6638),
  //   Rotation: new THREE.Vector3(0.0, 0.0, 0),
  //   Scale: 1,
  //   isIFrame: true,
  //   iFrameUrl: "./PanoTours/MDR//SEKUNDAER/FreilichtmuseumGosau/index.htm",
  //   offset: 15,
  //   offsetUp: 0,
  //   follow: true,
  //   lowModelCamZoom: 15,
  // },

]


export const  BadAusseeLabels = [
 


  {
    Id: "Annotation_AlpenGartenBadAusee",
    Titel: "Alpengarten Bad Aussee",
    TitelEn: "Alpengarten Bad Aussee",
    Position: new THREE.Vector3(446.784, 12.7995, 23.4556),
    Rotation: new THREE.Vector3(0.0, 0.0, 0),
    Scale: 1,
    isIFrame: true,
    iFrameUrl:"./PanoTours/MDR/SEKUNDAER/AlpenGartenBadAussee/index.htm",
    offset: 15,
    offsetUp: 0,
    follow: true,
    lowModelCamZoom: 15,
  },



]

export const  ObertraunLabels = [
 
  {
    Id: "Annotation_HoehlenmuseumObertraun",
    Titel: "Österreichisches Papiermacher- und Druckereimuseum Laakirchen",
    TitelEn: "Österreichisches Papiermacher- und Druckereimuseum Laakirchen",
    Position: new THREE.Vector3(652.712, 18.6623, 35.1447),
    Rotation: new THREE.Vector3(0.0, 0.0, 0),
    Scale: 1,
    isIFrame: true,
    iFrameUrl:"./PanoTours/MDR/PapiermacherMuseum/index.htm",
    offset: 25,
    offsetUp: 0,
    follow: true,
    lowModelCamZoom: 15,
  },

]

export const VorchdorfLabels = [
  {
    Id: "Annotation_MuseumDerRegionVorchdorf",
    Titel: "Museum der Region Vorchdorf",
    TitelEn: "Museum der Region Vorchdorf",
    Position: new THREE.Vector3(688.593, 14.7353, 76.382),
    Rotation: new THREE.Vector3(0.0, 0.0, 0),
    Scale: 1,
    isIFrame: true,
    iFrameUrl:"./PanoTours/MDR/SEKUNDAER/MuseumDerRegionVorchdorf/index.htm",
    offset: -15,
    offsetUp: 0,
    follow: true,
    lowModelCamZoom: 15,
  },



  {
    Id: "Annotation_SteingartenVorchdorf",
    Titel: "Oberösterreichischer Steingarten Vorchdorf",
    TitelEn: "Oberösterreichischer Steingarten Vorchdorf",
    Position: new THREE.Vector3(688.593, 10.7808, 76.382),
    Rotation: new THREE.Vector3(0.0, 0.0, 0),
    Scale: 1,
    isIFrame: true,
    iFrameUrl:"./PanoTours/MDR/SEKUNDAER/SteingartenVorchdorf/index.htm",
    offset: -15,
    offsetUp: 0,
    follow: true,
    lowModelCamZoom: 15,
  },

  // {
  //   Id: "Annotation_Scharnstein",
  //   Titel: "Scharnstein",
  //   Position: new THREE.Vector3(623.652, 14.0368, 87.4104),
  //   Rotation: new THREE.Vector3(0.0, 0.0, 0),
  //   Scale: 1,
  //   isIFrame: true,
  //   iFrameUrl:
  //     "https://sketchfab.com/models/7408d0dbd00e401bacdc789f2d82ea68/embed",
  //   offset: 15,
  //   offsetUp: 0,
  //   follow: true,
  //   lowModelCamZoom: 15,
  // },
  // {
  //   Id: "Annotation_VorchdorfEmailmuseum",
  //   Titel: "VorchdorfEmailmuseum",
  //   Position: new THREE.Vector3(688.593, 16.6393, 76.382),
  //   Rotation: new THREE.Vector3(0.0, 0.0, 0),
  //   Scale: 1,
  //   isIFrame: true,
  //   iFrameUrl:
  //     "https://sketchfab.com/models/7408d0dbd00e401bacdc789f2d82ea68/embed",
  //   offset: 15,
  //   offsetUp: 0,
  //   follow: true,
  //   lowModelCamZoom: 15,
  // },




  {
    Id: "Annotation_VorchdorefMotorradmuseum",
    Titel: "Motorradmuseum Vorchdorf",
    TitelEn: "Motorradmuseum Vorchdorf",
    Position: new THREE.Vector3(688.593, 18.6623, 76.382),
    Rotation: new THREE.Vector3(0.0, 0.0, 0),
    Scale: 1,
    isIFrame: true,
    iFrameUrl:"./PanoTours/MDR/SEKUNDAER/Motorradmuseum/index.htm",
    offset: -15,
    offsetUp: 0,
    follow: true,
    lowModelCamZoom: 15,
  },
 






];

export const  AltauseeLabels = [
 
  {
    Id: "Annotation_LiteraturmuseumBadAusee",
    Titel: "Literaturmuseum Altaussee",
    TitelEn: "Literaturmuseum Altaussee",
    Position: new THREE.Vector3(466.195, 14, 23.4556),
    Rotation: new THREE.Vector3(0.0, 0.0, 0),
    Scale: 1,
    isIFrame: true,
    iFrameUrl:"./PanoTours/MDR/SEKUNDAER/LiteraturmusemAltAusee/index.htm",
    offset: 15,
    offsetUp: 0,
    follow: true,
    lowModelCamZoom: 15,
  },
  {
    Id: "Annotation_Salzwelten Altaussee",
    Titel: "Salzwelten Altaussee",
    TitelEn: "Salzwelten Altaussee",
    Position: new THREE.Vector3(466.195, 10, 23.4556),
    Rotation: new THREE.Vector3(0.0, 0.0, 0),
    Scale: 1,
    isIFrame: true,
    iFrameUrl:"https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d86006.40170365997!2d13.656715278474257!3d47.65139530006445!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47714f2b5eaf00f7%3A0xfd4f97115dc7569!2sSalzwelten%20Altaussee!5e0!3m2!1sde!2sat!4v1716667304559!5m2!1sde!2sat",
    offset: 15,
    offsetUp: 0,
    follow: true,
    lowModelCamZoom: 15,
  },]


